import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useTheme } from 'styled-components'
import {
  RequirementWrapper,
  PasswordTips,
  IconWrapper
} from './SuccessPage/SuccessPage.styles'
import { Check, Close } from '@dsny/dsny-component-library/icons'

export default function PasswordValidation({
  displayTips,
  watchPassword,
  onValidation
}) {
  const { t } = useTranslation()
  const theme = useTheme()

  const hasMinimumSize = /.{7,}/
  const hasNumbers = /[0-9]/
  const hasSpecialCharacters = /[@$!%*#?&^;:"+=\-\\]/

  const validations = {
    hasMinimumSize: hasMinimumSize.test(watchPassword),
    hasNumbers: hasNumbers.test(watchPassword),
    hasSpecialCharacters: hasSpecialCharacters.test(watchPassword)
  }

  const renderIcon = (isValid) => {
    return isValid ? (
      <Check
        width={16}
        color={theme.colors.success60}
        style={{ marginRight: 4 }}
      />
    ) : (
      <Close
        width={16}
        style={{ marginRight: 2 }}
        color={theme.colors.neutralW70}
      />
    )
  }

  const passwordRequirements = [
    {
      validation: validations.hasMinimumSize,
      message: t('login.at-least-7-characters')
    },
    {
      validation: validations.hasNumbers,
      message: t('login.at-least-1-number')
    },
    {
      validation: validations.hasSpecialCharacters,
      message: t('login.at-least-1-special-character') + ' (@$!%*#?&^;:"+=\\-)'
    }
  ]

  useEffect(() => {
    onValidation(
      validations.hasMinimumSize &&
        validations.hasNumbers &&
        validations.hasSpecialCharacters
    )
  }, [watchPassword, onValidation])

  const shouldDisplayTips =
    displayTips &&
    !(
      validations.hasMinimumSize &&
      validations.hasNumbers &&
      validations.hasSpecialCharacters
    )

  return (
    <>
      {shouldDisplayTips && (
        <RequirementWrapper>
          <p>{t('login.password-must-contain')}</p>
          {passwordRequirements.map((requirement, index) => (
            <PasswordTips key={index} $isInvalid={!requirement.validation}>
              <IconWrapper>{renderIcon(requirement.validation)}</IconWrapper>
              {requirement.message}
            </PasswordTips>
          ))}
        </RequirementWrapper>
      )}
    </>
  )
}
